import { useTranslation } from 'react-i18next'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { ensureExists } from '~/utils'

import { pathKey } from '../utils'

export const useDocumentReportId = () => {
  const { t } = useTranslation()
  const { documentReportId } = usePathParams(pathKey)

  return ensureExists(documentReportId, t('assertion_failed'))
}
